import SampleSpreadsheetUrl from '../../../../assets/files/Maptive_Sample_Data_Set.xls';

export const SAMPLE_SPREADSHEET_FILE_NAME = 'Maptive_Sample_Data_Set.xls';
export { SampleSpreadsheetUrl };
